export default __webpack_public_path__ + "static/media/content_copy.83fc81b8.svg";